import countries from "i18n-iso-countries";
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

export const getCountryAlpha2Code = (countryName) => {
    return countries.getAlpha2Code(countryName, "en"); 
};